<div class="cmdk-list-content" role="listbox" [attr.aria-label]="ariaLabel" #height>
    <ng-content></ng-content>
</div>